var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackSomething(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 30,
    viewBox: "0 0 64 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0244 5.33594H49.3764L48.43 8.50503H38.0782L39.0244 5.33594ZM30.2743 26.3699C30.1549 26.7282 29.9519 27.0864 29.6653 27.4446C29.3787 27.779 29.0443 28.0895 28.6622 28.3761C28.304 28.6388 27.9219 28.8537 27.5158 29.0209C27.1098 29.1881 26.7397 29.2717 26.4053 29.2717H9.8189C9.48455 29.2717 9.17408 29.1881 8.88749 29.0209C8.60089 28.8537 8.36207 28.6388 8.17101 28.3761C8.00383 28.0895 7.89636 27.779 7.8486 27.4446C7.80083 27.0864 7.83665 26.7282 7.95607 26.3699L9.92637 20.6381H15.085L13.7595 24.4354H25.7605L27.086 20.6381H32.2446L30.2743 26.3699ZM34.5731 13.545C34.5493 13.5928 34.5373 13.7003 34.5373 13.8674L34.4657 14.154L34.0716 15.2287H11.7534L12.1474 14.154C12.1952 14.0585 12.231 13.963 12.2549 13.8674C12.3027 13.7719 12.3624 13.6644 12.434 13.545H34.5731ZM32.6028 11.2523C33.0327 11.2523 33.4148 11.3837 33.7492 11.6464C34.0835 11.9091 34.3224 12.2434 34.4657 12.6494H13.1505C13.5804 12.2434 14.0581 11.9091 14.5835 11.6464C15.1089 11.3837 15.5865 11.2523 16.0164 11.2523H32.6028ZM28.6622 16.0885H16.6612L16.0522 17.808H10.8936L11.5384 15.9094H33.8567L33.2118 17.808H28.0532L28.6622 16.0885ZM9.99802 20.3874L10.7145 18.2738H15.9089L15.1566 20.3874H9.99802ZM27.1576 20.3874L27.9099 18.2738H33.0327L32.3162 20.3874H27.1576ZM54.8681 26.3699C54.7487 26.7282 54.5457 27.0864 54.2591 27.4446C53.9725 27.779 53.6382 28.0895 53.2561 28.3761C52.8978 28.6388 52.5157 28.8537 52.1097 29.0209C51.7037 29.1881 51.3335 29.2717 50.9992 29.2717H34.4128C34.0784 29.2717 33.7679 29.1881 33.4813 29.0209C33.1948 28.8537 32.9559 28.6388 32.7649 28.3761C32.5977 28.0895 32.4902 27.779 32.4425 27.4446C32.3947 27.0864 32.4305 26.7282 32.5499 26.3699L34.5202 20.6381H39.6789L38.3534 24.4354H50.3543L51.6798 20.6381H56.8385L54.8681 26.3699ZM59.167 13.545C59.1431 13.5928 59.1312 13.7003 59.1312 13.8674L59.0595 14.154L58.6655 15.2287H36.3473L36.7413 14.154C36.7891 14.0585 36.8249 13.963 36.8488 13.8674C36.8965 13.7719 36.9563 13.6644 37.0279 13.545H59.167ZM57.1967 11.2523C57.6266 11.2523 58.0087 11.3837 58.343 11.6464C58.6774 11.9091 58.9162 12.2434 59.0595 12.6494H37.7444C38.1743 12.2434 38.6519 11.9091 39.1773 11.6464C39.7027 11.3837 40.1804 11.2523 40.6103 11.2523H57.1967ZM53.2561 16.0885H41.2551L40.6461 17.808H35.4875L36.1323 15.9094H58.4505L57.8057 17.808H52.6471L53.2561 16.0885ZM34.5919 20.3874L35.3084 18.2738H40.5028L39.7505 20.3874H34.5919ZM51.7515 20.3874L52.5038 18.2738H57.6266L56.9101 20.3874H51.7515ZM25.0067 5.33594H14.6546L13.7084 8.50503H24.0602L25.0067 5.33594Z",
    fill: "url(#paint0_linear_1772_11159)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1176 11.6254H60.2353V13.5077H62.1176V11.6254Z",
    fill: "#B3B3B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0002 13.5081L62.1176 13.5077L62.1179 15.3904H64.0002V13.5081Z",
    fill: "#B3B3B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0002 15.3904H62.1179V17.273H64.0002V15.3904Z",
    fill: "#B3B3B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1179 15.3904L60.2353 15.3907V17.273H62.1179V15.3904Z",
    fill: "#B3B3B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1176 17.2513H60.2353V19.1336H62.1176V17.2513Z",
    fill: "#B3B3B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2353 19.1336L58.3523 19.134V21.0162H60.2346L60.2353 19.1336Z",
    fill: "#B3B3B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2353 15.3907H58.3523V17.273H60.2353V15.3907Z",
    fill: "#B3B3B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2353 17.2513H58.3523V19.134L60.2353 19.1336V17.2513Z",
    fill: "#B3B3B9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3523 19.134H56.4711V21.0162H58.3523V19.134Z",
    fill: "#B3B3B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3523 21.0162H56.4711V22.898H58.3533L58.3523 21.0162Z",
    fill: "#B3B3B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4711 21.0162L54.5889 21.0157V22.898H56.4711V21.0162Z",
    fill: "#B3B3B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5889 21.0157H52.7064V22.898H54.5889V21.0157Z",
    fill: "#B3B3B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4711 22.898H54.5889V24.7806H56.4712L56.4711 22.898Z",
    fill: "#B3B3B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.001 22.8983H30.1187V24.7806H32.001V22.8983Z",
    fill: "#B3B3B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5889 22.898H52.7064L52.7055 24.7806H54.5889V22.898Z",
    fill: "#B3B3B9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1187 22.8983H28.237V24.7806H30.1187V22.8983Z",
    fill: "#B3B3B9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2367 21.0157H26.3544V22.898L28.237 22.8983L28.2367 21.0157Z",
    fill: "#B3B3B9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2367 19.134H26.3544V21.0157H28.2367V19.134Z",
    fill: "#B3B3B9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2367 17.2513H26.3544V19.134H28.2367V17.2513Z",
    fill: "#B3B3B9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1184 17.2513H28.2367V19.134L30.1184 19.1336V17.2513Z",
    fill: "#B3B3B9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7064 22.898L50.8238 22.8983V24.7806H52.7055L52.7064 22.898Z",
    fill: "#B3B3B9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.237 22.8983L26.3544 22.898V24.7806H28.237V22.8983Z",
    fill: "#B3B3B9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3544 21.0157H24.4727V22.898H26.3544V21.0157Z",
    fill: "#B3B3B9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3544 19.134H24.4727V21.0157H26.3544V19.134Z",
    fill: "#B3B3B9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3544 17.2513H24.4727V19.134H26.3544V17.2513Z",
    fill: "#B3B3B9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7064 21.0157H50.8238V22.8983L52.7064 22.898V21.0157Z",
    fill: "#B3B3B9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7061 19.1541H50.8238V21.0364H52.7061V19.1541Z",
    fill: "#B3B3B9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7061 17.2724H50.8238V19.1541H52.7061V17.2724Z",
    fill: "#B3B3B9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5878 17.2724H52.7061V19.1541L54.5878 19.1547V17.2724Z",
    fill: "#B3B3B9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9419 17.2724H47.0596V19.1547H48.9419V17.2724Z",
    fill: "#B3B3B9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9419 19.134H47.0596V21.0162H48.9419V19.134Z",
    fill: "#B3B3B9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9419 21.0162H47.0596V22.898H48.9419V21.0162Z",
    fill: "#B3B3B9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8238 22.8983L48.9419 22.898L48.9421 24.7806H50.8238V22.8983Z",
    fill: "#B3B3B9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3544 22.898H24.4727V24.7806H26.3544V22.898Z",
    fill: "#B3B3B9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 21.0157H22.5902V22.898H24.4727V21.0157Z",
    fill: "#B3B3B9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 19.134H22.5902V21.0157H24.4727V19.134Z",
    fill: "#B3B3B9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5902 19.134H20.7072V21.0162L22.5902 21.0157V19.134Z",
    fill: "#B3B3B9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 17.2513H22.5902V19.134H24.4727V17.2513Z",
    fill: "#B3B3B9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5902 17.2513H20.7072V19.134H22.5902V17.2513Z",
    fill: "#B3B3B9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7072 17.2513H18.8259V19.1336L20.7072 19.134V17.2513Z",
    fill: "#B3B3B9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8238 21.0157L48.9419 21.0162V22.898L50.8238 22.8983V21.0157Z",
    fill: "#B3B3B9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8238 19.1541L48.9419 19.1547L48.9421 21.0364H50.8238V19.1541Z",
    fill: "#B3B3B9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8238 17.2724H48.9419V19.1547L50.8238 19.1541V17.2724Z",
    fill: "#B3B3B9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0596 17.2724H45.177V19.1547H47.0596V17.2724Z",
    fill: "#B3B3B9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6478 17.2724H35.7655V19.1547H37.6478V17.2724Z",
    fill: "#B3B3B9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7661 19.134H33.8838V21.0162H35.7661V19.134Z",
    fill: "#B3B3B9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8838 21.0162L32.0013 21.0157L32.001 22.8983L33.8835 22.898L33.8838 21.0162Z",
    fill: "#B3B3B9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M45.177 17.2724H43.2945V19.1547H45.177V17.2724Z",
    fill: "#B3B3B9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7655 17.2724H33.8838V19.1547H35.7655V17.2724Z",
    fill: "#B3B3B9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8838 19.134H32.0013V21.0157L33.8838 21.0162V19.134Z",
    fill: "#B3B3B9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.001 17.2724H30.1187V19.1547H32.001V17.2724Z",
    fill: "#B3B3B9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1193 21.0157H28.2367L28.237 22.8983H30.1187L30.1193 21.0157Z",
    fill: "#B3B3B9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0013 21.0157H30.1193L30.1187 22.8983H32.001L32.0013 21.0157Z",
    fill: "#B3B3B9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0596 19.134H45.177V21.0162H47.0596V19.134Z",
    fill: "#B3B3B9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4712 17.2724H54.5878V19.1547H56.4712V17.2724Z",
    fill: "#B3B3B9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3523 15.3907H56.4711L56.4712 17.2724L58.3523 17.273V15.3907Z",
    fill: "#B3B3B9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4711 15.3907H54.5889L54.5878 17.2724H56.4712L56.4711 15.3907Z",
    fill: "#B3B3B9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5889 15.3907H52.7055L52.7061 17.2724H54.5878L54.5889 15.3907Z",
    fill: "#B3B3B9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7055 15.3907H50.8238V17.2724H52.7061L52.7055 15.3907Z",
    fill: "#B3B3B9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8238 15.3907H48.9421L48.9419 17.2724H50.8238V15.3907Z",
    fill: "#B3B3B9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9421 15.3907H47.0596V17.2724H48.9419L48.9421 15.3907Z",
    fill: "#B3B3B9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0596 15.3907H45.177V17.2724H47.0596V15.3907Z",
    fill: "#B3B3B9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.177 15.3907H43.2945V17.2724H45.177V15.3907Z",
    fill: "#B3B3B9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2945 15.3907H41.4128V17.273L43.2945 17.2724V15.3907Z",
    fill: "#B3B3B9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4128 15.3907H39.5306V17.273H41.4128V15.3907Z",
    fill: "#B3B3B9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5306 15.3907H37.6477L37.6478 17.2724L39.5306 17.273V15.3907Z",
    fill: "#B3B3B9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6477 15.3907H35.7655V17.2724H37.6478L37.6477 15.3907Z",
    fill: "#B3B3B9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7655 15.3907H33.8838V17.2724H35.7655V15.3907Z",
    fill: "#B3B3B9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8838 15.3907H32.0013L32.001 17.2724H33.8838V15.3907Z",
    fill: "#B3B3B9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0013 15.3907H30.1187V17.2724H32.001L32.0013 15.3907Z",
    fill: "#B3B3B9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1187 15.3907H28.237V17.273L30.1187 17.2724V15.3907Z",
    fill: "#B3B3B9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M28.237 15.3907H26.3544V17.273H28.237V15.3907Z",
    fill: "#B3B3B9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3544 15.3907H24.4727V17.273H26.3544V15.3907Z",
    fill: "#B3B3B9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 15.3907H22.5902V17.273H24.4727V15.3907Z",
    fill: "#B3B3B9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5902 15.3907H20.7072V17.273H22.5902V15.3907Z",
    fill: "#B3B3B9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7072 15.3907H18.8259V17.273H20.7072V15.3907Z",
    fill: "#B3B3B9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8259 15.3907H16.943V17.273H18.8259V15.3907Z",
    fill: "#B3B3B9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9427 13.5081H15.0604V15.3904L16.943 15.3907L16.9427 13.5081Z",
    fill: "#B3B3B9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15.061 11.6254H13.1787V13.5077L15.0604 13.5081L15.061 11.6254Z",
    fill: "#B3B3B9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1784 9.74284H11.2961V11.6251L13.1787 11.6254L13.1784 9.74284Z",
    fill: "#B3B3B9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2346 9.74284H58.3523V11.6251L60.2353 11.6254L60.2346 9.74284Z",
    fill: "#B3B3B9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2959 7.86019H9.41359V9.74247L11.2961 9.74284L11.2959 7.86019Z",
    fill: "#B3B3B9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3521 7.86019H56.4698V9.74247L58.3523 9.74284L58.3521 7.86019Z",
    fill: "#B3B3B9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41333 5.97756H7.53104V7.85984L9.41359 7.86019L9.41333 5.97756Z",
    fill: "#B3B3B9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4695 5.97756H54.5872V7.85984L56.4698 7.86019L56.4695 5.97756Z",
    fill: "#B3B3B9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53036 4.09493H5.64807V5.97721L7.53104 5.97756L7.53036 4.09493Z",
    fill: "#B3B3B9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M54.587 4.09493H52.7047V5.97721L54.5872 5.97756L54.587 4.09493Z",
    fill: "#B3B3B9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64781 2.21337H3.76552V4.09566L5.64807 4.09493L5.64781 2.21337Z",
    fill: "#B3B3B9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M52.704 2.21295H50.8217V4.09524L52.7047 4.09493L52.704 2.21295Z",
    fill: "#B3B3B9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76552 2.21337L1.88297 2.2129V4.09519L3.76552 4.09566V2.21337Z",
    fill: "#B3B3B9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88297 2.2129H0V4.09519H1.88297V2.2129Z",
    fill: "#B3B3B9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8215 0.332031H48.9392V2.21432H50.8215V0.332031Z",
    fill: "#B3B3B9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9392 0.332031H47.0562V2.21432H48.9392V0.332031Z",
    fill: "#B3B3B9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0562 0.332031H45.1741V2.21432H47.0562V0.332031Z",
    fill: "#B3B3B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_11159",
    x1: 33.4976,
    y1: 5.33594,
    x2: 33.4976,
    y2: 29.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSomething);
export default __webpack_public_path__ + "static/media/BlackSomething.bde02347398e02e8e091dc63b06dc778.svg";
export { ForwardRef as ReactComponent };